
import { Avatar, theme, Grid, Space, Dropdown } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import useAuthState from '@/hooks/useAuthState';
import { useAppDispatch } from '@/AppRedux/store/hooks';
import { logout } from '@/AppRedux/actions/auth';

const { useBreakpoint } = Grid;

const UserProfile = () => {
  const { useToken } = theme;
  const { token: antdToken } = useToken();
  const screens = useBreakpoint();
  const { user } = useAuthState();
  const dispatch = useAppDispatch();

  const onLogout = () => {
    dispatch(logout());
  };

  // เมนู Dropdown สำหรับ User Profile
  const userMenu = [
    {
      key: '1',
      label: 'My Profile',
      icon: <UserOutlined />,
    },
    {
      type: 'divider',
    },
    {
      key: '2',
      label: 'Logout',
      icon: <LogoutOutlined />,
      danger: true,
      onClick: onLogout,
    },
  ];

  return (
    <Dropdown menu={{ items: userMenu as any }} placement="bottomRight" arrow>
    <Space style={{ cursor: 'pointer', padding: '4px 8px', borderRadius: antdToken.borderRadius }} className="user-dropdown">
      <Avatar
        style={{ backgroundColor: antdToken.colorPrimary, verticalAlign: 'middle' }}
        src={user?.profilePic || undefined}
        icon={<UserOutlined />}
      />
      <span style={{ color: antdToken.colorText, fontWeight: 500, display: `${screens.md ? 'block' : 'none'}`, textTransform: 'capitalize'}}>
        {user?.name || 'Administrator'}
      </span>
    </Space>
    </Dropdown>
  );
};

export default UserProfile;
